"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DateTime", {
  enumerable: true,
  get: function get() {
    return _DateTime["default"];
  }
});
Object.defineProperty(exports, "NonPositiveInt", {
  enumerable: true,
  get: function get() {
    return _NonPositiveInt["default"];
  }
});
Object.defineProperty(exports, "PositiveInt", {
  enumerable: true,
  get: function get() {
    return _PositiveInt["default"];
  }
});
Object.defineProperty(exports, "NonNegativeInt", {
  enumerable: true,
  get: function get() {
    return _NonNegativeInt["default"];
  }
});
Object.defineProperty(exports, "UnsignedInt", {
  enumerable: true,
  get: function get() {
    return _NonNegativeInt["default"];
  }
});
Object.defineProperty(exports, "NegativeInt", {
  enumerable: true,
  get: function get() {
    return _NegativeInt["default"];
  }
});
Object.defineProperty(exports, "NonPositiveFloat", {
  enumerable: true,
  get: function get() {
    return _NonPositiveFloat["default"];
  }
});
Object.defineProperty(exports, "PositiveFloat", {
  enumerable: true,
  get: function get() {
    return _PositiveFloat["default"];
  }
});
Object.defineProperty(exports, "NonNegativeFloat", {
  enumerable: true,
  get: function get() {
    return _NonNegativeFloat["default"];
  }
});
Object.defineProperty(exports, "UnsignedFloat", {
  enumerable: true,
  get: function get() {
    return _NonNegativeFloat["default"];
  }
});
Object.defineProperty(exports, "NegativeFloat", {
  enumerable: true,
  get: function get() {
    return _NegativeFloat["default"];
  }
});
Object.defineProperty(exports, "EmailAddress", {
  enumerable: true,
  get: function get() {
    return _EmailAddress.EmailAddress;
  }
});
Object.defineProperty(exports, "EmailAddressWithTLD", {
  enumerable: true,
  get: function get() {
    return _EmailAddress.EmailAddressWithTLD;
  }
});
Object.defineProperty(exports, "EMAIL_ADDRESS_REGEX_WITH_TLD", {
  enumerable: true,
  get: function get() {
    return _EmailAddress.EMAIL_ADDRESS_REGEX_WITH_TLD;
  }
});
Object.defineProperty(exports, "URL", {
  enumerable: true,
  get: function get() {
    return _URL["default"];
  }
});
Object.defineProperty(exports, "PhoneNumber", {
  enumerable: true,
  get: function get() {
    return _PhoneNumber["default"];
  }
});
Object.defineProperty(exports, "PostalCode", {
  enumerable: true,
  get: function get() {
    return _PostalCode["default"];
  }
});
Object.defineProperty(exports, "RegularExpression", {
  enumerable: true,
  get: function get() {
    return _RegularExpression["default"];
  }
});
Object.defineProperty(exports, "DateTimeScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.DateTimeScalar;
  }
});
Object.defineProperty(exports, "EmailAddressScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.EmailAddressScalar;
  }
});
Object.defineProperty(exports, "NegativeFloatScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.NegativeFloatScalar;
  }
});
Object.defineProperty(exports, "NegativeIntScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.NegativeIntScalar;
  }
});
Object.defineProperty(exports, "NonNegativeFloatScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.NonNegativeFloatScalar;
  }
});
Object.defineProperty(exports, "NonNegativeIntScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.NonNegativeIntScalar;
  }
});
Object.defineProperty(exports, "NonPositiveFloatScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.NonPositiveFloatScalar;
  }
});
Object.defineProperty(exports, "NonPositiveIntScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.NonPositiveIntScalar;
  }
});
Object.defineProperty(exports, "PhoneNumberScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.PhoneNumberScalar;
  }
});
Object.defineProperty(exports, "PositiveFloatScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.PositiveFloatScalar;
  }
});
Object.defineProperty(exports, "PositiveIntScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.PositiveIntScalar;
  }
});
Object.defineProperty(exports, "PostalCodeScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.PostalCodeScalar;
  }
});
Object.defineProperty(exports, "RegularExpressionScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.RegularExpressionScalar;
  }
});
Object.defineProperty(exports, "UnsignedFloatScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.UnsignedFloatScalar;
  }
});
Object.defineProperty(exports, "UnsignedIntScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.UnsignedIntScalar;
  }
});
Object.defineProperty(exports, "URLScalar", {
  enumerable: true,
  get: function get() {
    return _scalars.URLScalar;
  }
});
Object.defineProperty(exports, "ScalarDefinitions", {
  enumerable: true,
  get: function get() {
    return _scalars["default"];
  }
});
exports["default"] = void 0;

var _DateTime = _interopRequireDefault(require("./DateTime"));

var _NonPositiveInt = _interopRequireDefault(require("./NonPositiveInt"));

var _PositiveInt = _interopRequireDefault(require("./PositiveInt"));

var _NonNegativeInt = _interopRequireDefault(require("./NonNegativeInt"));

var _NegativeInt = _interopRequireDefault(require("./NegativeInt"));

var _NonPositiveFloat = _interopRequireDefault(require("./NonPositiveFloat"));

var _PositiveFloat = _interopRequireDefault(require("./PositiveFloat"));

var _NonNegativeFloat = _interopRequireDefault(require("./NonNegativeFloat"));

var _NegativeFloat = _interopRequireDefault(require("./NegativeFloat"));

var _EmailAddress = require("./EmailAddress");

var _URL = _interopRequireDefault(require("./URL"));

var _PhoneNumber = _interopRequireDefault(require("./PhoneNumber"));

var _PostalCode = _interopRequireDefault(require("./PostalCode"));

var _RegularExpression = _interopRequireDefault(require("./RegularExpression"));

var _scalars = _interopRequireWildcard(require("./scalars"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  // as part of a default object
  DateTime: _DateTime["default"],
  PositiveInt: _PositiveInt["default"],
  NonNegativeInt: _NonNegativeInt["default"],
  UnsignedInt: _NonNegativeInt["default"],
  NegativeInt: _NegativeInt["default"],
  PositiveFloat: _PositiveFloat["default"],
  NonNegativeFloat: _NonNegativeFloat["default"],
  UnsignedFloat: _NonNegativeFloat["default"],
  NegativeFloat: _NegativeFloat["default"],
  EmailAddress: _EmailAddress.EmailAddress,
  EmailAddressWithTLD: _EmailAddress.EmailAddressWithTLD,
  URL: _URL["default"],
  PhoneNumber: _PhoneNumber["default"],
  PostalCode: _PostalCode["default"],
  RegularExpression: _RegularExpression["default"]
};
exports["default"] = _default;